import { useMatch } from "@tanstack/react-router";
import { useQueryClient } from "@tanstack/react-query";
import { EnvConfig } from "@/config/env";
import { QueryKeysConfig } from "@/config/query-keys";
import type { TPost } from "@/network/typings";
import cls from "./styles.module.css";

interface AdminBarProps {
  userName: string;
}

const wpAdmin = `${EnvConfig.siteUrl}/wp-admin`;

export default function AdminBar({ userName }: AdminBarProps) {
  const postSlug = useMatch({ from: "/post/$slug", shouldThrow: false })?.params
    ?.slug;
  const queryClient = useQueryClient();

  const postId = postSlug
    ? queryClient.getQueryData<TPost>([
        QueryKeysConfig.postBySlug,
        { slug: postSlug },
      ])?.id
    : undefined;

  return (
    <div className={cls.root}>
      <div className={cls.group}>
        <a
          rel="noopener noreferrer"
          target="_blank"
          className={cls.link}
          href={`${wpAdmin}/index.php`}
          title="Панель управления"
        >
          Orha
        </a>
        <a
          rel="noopener noreferrer"
          target="_blank"
          className={cls.link}
          href={`${wpAdmin}/post-new.php`}
        >
          +&nbsp;Новое
        </a>
        {postId && (
          <a
            rel="noopener noreferrer"
            className={cls.link}
            href={`${wpAdmin}/post.php?post=${postId}&action=edit`}
          >
            Изменить
          </a>
        )}
        <a
          rel="noopener noreferrer"
          target="_blank"
          className={cls.link}
          href={`${wpAdmin}/edit-comments.php`}
        >
          Комментарии
        </a>
      </div>
      <div className={`${cls.group} ${cls.separator}`}>
        <a
          className={`${cls.link} ${cls.userName}`}
          href={`${wpAdmin}/profile.php`}
        >
          Привет, {userName}
        </a>
        <a
          className={cls.link}
          href={`${EnvConfig.siteUrl}/wp-login.php?action=logout`}
        >
          Выйти
        </a>
      </div>
    </div>
  );
}
